function getDeliveryEstimation(deliveryDays, defaultEstimation) {
    var ref;
    if ((ref = !deliveryDays.length) !== null && ref !== void 0 ? ref : !deliveryDays[0]) {
        return defaultEstimation;
    }
    let slowest = [
        0,
        0
    ] // [value, index]
    ;
    deliveryDays.forEach((value, index)=>{
        // Strip out anything except numbers and -
        const cleanValue = value.replace(/[^\d-]/g, '');
        // If we have a bound value (like 1-3), take the first number.
        const days = Number(cleanValue.split('-')[0]);
        if (days > slowest[0]) {
            slowest = [
                days,
                index
            ];
        }
    });
    var ref1;
    // Return the string representation.
    return (ref1 = deliveryDays[slowest[1]]) !== null && ref1 !== void 0 ? ref1 : deliveryDays[0];
}

export { getDeliveryEstimation };
//# sourceMappingURL=get-delivery-estimation.js.map
